import React, { useEffect, useState, useContext, useRef } from "react";
import { getCustomerTransacton } from "../../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { getFormattedCurrentDate2, NaviGate, shop_id } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import "./../table.css";

const CustomerTransaction = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const contentRef = useRef(null);
    const [data, setData] = useState([]);
    const [filterType, setFilterType] = useState("daily");
    const [selectedDate, setSelectedDate] = useState(getFormattedCurrentDate2());
    const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek());
    const [selectedMonth, setSelectedMonth] = useState(getFormattedCurrentDate2().substring(0, 7));
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [customFromDate, setCustomFromDate] = useState("");
    const [customToDate, setCustomToDate] = useState("");
    const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
    const [toDate, setToDate] = useState(getFormattedCurrentDate2());
    const [searchText, setSearchText] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [paymentFilter, setPaymentFilter] = useState("");
    const [companyInfo, setCompanyInfo] = useState({
        name: "Company Name",
        address: "123 Business Street, City, State 12345",
        phone: "(123) 456-7890",
        email: "info@yourcompany.com"
    });
    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "",
                address: shopItem?.Address || "123 Business Street, City, State 12345",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            })
        }

    }, [shopItem])


    // Helper function to get current week range
    function getCurrentWeek() {
        const today = new Date();
        const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
        const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));

        return {
            start: firstDay.toISOString().split('T')[0],
            end: lastDay.toISOString().split('T')[0]
        };
    }

    // Helper function to get week range from date
    function getWeekRange(dateString) {
        const date = new Date(dateString);
        const firstDay = new Date(date.setDate(date.getDate() - date.getDay()));
        const lastDay = new Date(date.setDate(date.getDate() - date.getDay() + 6));

        return {
            start: firstDay.toISOString().split('T')[0],
            end: lastDay.toISOString().split('T')[0]
        };
    }

    useEffect(() => {
        updateDateRange();
    }, [filterType, selectedDate, selectedWeek, selectedMonth, selectedYear, customFromDate, customToDate]);

    useEffect(() => {
        if (fromDate && toDate) {
            fetchData();
        }
    }, [fromDate, toDate]);

    const updateDateRange = () => {
        let startDate = "";
        let endDate = "";

        switch (filterType) {
            case "daily":
                startDate = selectedDate;
                endDate = selectedDate;
                break;
            case "weekly":
                startDate = selectedWeek.start;
                endDate = selectedWeek.end;
                break;
            case "monthly":
                startDate = `${selectedMonth}-01`;
                const lastDay = new Date(
                    new Date(startDate).getFullYear(),
                    new Date(startDate).getMonth() + 1,
                    0
                ).getDate();
                endDate = `${selectedMonth}-${lastDay}`;
                break;
            case "yearly":
                startDate = `${selectedYear}-01-01`;
                endDate = `${selectedYear}-12-31`;
                break;
            case "custom":
                startDate = customFromDate;
                endDate = customToDate;
                break;
            default:
                break;
        }

        setFromDate(startDate);
        setToDate(endDate);
    };

    const fetchData = async () => {
        try {
            showLoader();
            let filter = `from_date=${fromDate}&to_date=${toDate}&shop_id=${shop_id}`;
            const response = await getCustomerTransacton(filter);

            if (response.data && response.data.data) {
                let fetchedData = response.data.data.map(item => ({
                    ...item,
                    mop: item.mop === "1" ? "Cash" :
                        item.mop === "2" ? "Credit" :
                            item.mop === "4" ? "Card" : "Unknown"
                }));

                setData(fetchedData);
            } else {
                setData([]);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching customer transactions:", error);
        }
    };

    const handleWeekChange = (dateString) => {
        setSelectedWeek(getWeekRange(dateString));
    };

    const handlePrint = () => {
        // Create a new window for printing
        const printWindow = window.open('', '_blank');

        // Get the printable content
        const printContent = document.getElementById('printable-report').innerHTML;

        // Write the content to the new window
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Customer Transaction Report</title>
                <style>
                    @media print {
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12pt;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 21cm;
                            margin: 0 auto;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 15px;
                        }
                        .print-header h1 {
                            font-size: 20pt;
                            margin: 0;
                            color: #000;
                        }
                        .print-header p {
                            margin: 5px 0;
                            font-size: 11pt;
                        }
                        .report-info {
                            margin: 15px 0;
                            padding: 10px;
                            background-color: #f8f9fa;
                            border-radius: 5px;
                        }
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                            font-size: 10pt;
                        }
                        .report-table th, .report-table td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        .report-table th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        .report-totals {
                            margin-top: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            display: flex;
                            justify-content: space-between;
                            margin: 5px 0;
                        }
                        .total-amount {
                            font-weight: bold;
                            font-size: 13pt;
                        }
                        .text-success {
                            color: #28a745 !important;
                        }
                        .text-danger {
                            color: #dc3545 !important;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10pt;
                            color: #6c757d;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    // Print automatically when the window loads
                    window.onload = function() {
                        window.print();
                        // Close the window after printing
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    };

    const applyFilters = () => {
        let filtered = [...data];

        // Filter by customer
        if (selectedCustomer) {
            filtered = filtered.filter(item => item.customer_id === selectedCustomer);
        }

        // Filter by payment type
        if (paymentFilter === "paid") {
            filtered = filtered.filter(item => item.mop === "Cash" || item.mop === "Card");
        } else if (paymentFilter === "unpaid") {
            filtered = filtered.filter(item => item.mop === "Credit");
        }

        // Filter by search text
        if (searchText) {
            const search = searchText.toLowerCase();
            filtered = filtered.filter(item =>
                item.order_id?.toLowerCase().includes(search) ||
                item.customer_name?.toLowerCase().includes(search)
            );
        }

        return filtered.filter(item => item.status !== "-1");
    };

    const filteredData = applyFilters();

    const renderFilterControls = () => {
        switch (filterType) {
            case "daily":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="selectedDate"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                            <label htmlFor="selectedDate">Select Date</label>
                        </div>
                    </div>
                );
            case "weekly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="weekDate"
                                value={selectedWeek.start}
                                onChange={(e) => handleWeekChange(e.target.value)}
                            />
                            <label htmlFor="weekDate">Select Week</label>
                        </div>
                    </div>
                );
            case "monthly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="month"
                                className="form-control"
                                id="selectedMonth"
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            />
                            <label htmlFor="selectedMonth">Select Month</label>
                        </div>
                    </div>
                );
            case "yearly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="selectedYear"
                                min="2000"
                                max="2100"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                            />
                            <label htmlFor="selectedYear">Select Year</label>
                        </div>
                    </div>
                );
            case "custom":
                return (
                    <>
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customFromDate"
                                    value={customFromDate}
                                    onChange={(e) => setCustomFromDate(e.target.value)}
                                />
                                <label htmlFor="customFromDate">From Date</label>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customToDate"
                                    value={customToDate}
                                    onChange={(e) => setCustomToDate(e.target.value)}
                                />
                                <label htmlFor="customToDate">To Date</label>
                            </div>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    const goToCustomerDetails = (supplier) => {
        navigate(`/Customer_details?customer_id=${supplier.customer_id}`, {
            state: { supplier },
        });
    };
  

    // Calculate totals
    const totalPaid = filteredData
        .filter((f) => (f.mop === "Cash" || f.mop === "Card"))
        .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

    const totalUnpaid = filteredData
        .filter((f) => f.mop === "Credit")
        .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

    const totalAmount = totalPaid + totalUnpaid;

    return (
        <div className="page-wrappers">
            <div className="page-content py-1" ref={contentRef}>
                <NaviGate />

                {/* Filters Section */}
                <form className="card p-4 shadow-sm">
                    <div className="row g-3 justify-content-between align-items-center mb-3">
                        <h5 className="text-uppercase col-md-3">Customer Transaction</h5>

                        <div className="col-md-9 row g-3 justify-content-end">
                            {/* Filter Type Dropdown */}
                            <div className="col-md-2">
                                <div className="form-floating">
                                    <select
                                        className="form-select"
                                        id="filterType"
                                        value={filterType}
                                        onChange={(e) => setFilterType(e.target.value)}
                                    >
                                        <option value="daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="yearly">Yearly</option>
                                        <option value="custom">Custom Range</option>
                                    </select>
                                    <label htmlFor="filterType">Filter By</label>
                                </div>
                            </div>

                            {renderFilterControls()}

                            {/* Search Input */}
                            <div className="col-md-2">
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                    <label>Search Order/Customer</label>
                                </div>
                            </div>

                            {/* Payment Type Dropdown */}
                            <div className="col-md-2">
                                <div className="form-floating">
                                    <select
                                        className="form-select"
                                        value={paymentFilter}
                                        onChange={(e) => setPaymentFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="paid">Paid</option>
                                        <option value="unpaid">Unpaid</option>
                                    </select>
                                    <label>Payment Type</label>
                                </div>
                            </div>

                            {/* Customer Dropdown */}
                            <div className="col-md-2">
                                <div className="form-floating">
                                    <select
                                        className="form-select"
                                        value={selectedCustomer}
                                        onChange={(e) => setSelectedCustomer(e.target.value)}
                                    >
                                        <option value="">All Customers</option>
                                        {[...new Set(data
                                            .map((customer) => customer.customer_id).filter(Boolean))]
                                            .map((customer, index) => (
                                                <option key={index} value={customer}>
                                                    {data.find((dd) => dd.customer_id == customer)?.customer_name}
                                                </option>
                                            ))}
                                    </select>
                                    <label>Customer</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-3 justify-content-end">
                        {/* Print Button */}
                        <div className="col-md-2">
                            <button type="button" className="btn btn-dark p-3 fw-semibold w-100" onClick={handlePrint}>
                                Print Report
                            </button>
                        </div>
                    </div>

                    {/* Date Range Info */}
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="alert alert-info py-2">
                                <strong>Date Range:</strong> {fromDate} to {toDate} |
                                <strong> Total Records:</strong> {filteredData.length}
                                {searchText && (
                                    <span> | <strong>Filtered by:</strong> Order/Customer containing "{searchText}"</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive text-center my-2 w-100 position-relative">
                        <table className="table table-sm table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Order No</th>
                                    <th>Customer Name</th>
                                    <th>MOP</th>
                                    <th>Paid</th>
                                    <th>UnPaid</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    <>
                                        {filteredData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.date}</td>
                                                <td>{item.order_id}</td>
                                                {item.mop === "Credit" ?
                                                    <td onClick={() => { goToCustomerDetails(item) }} className="text-info pointer"> {item.customer_name}</td>
                                                    : <td>{item.customer_name}</td>
                                                }
                                                <td>{item.mop}</td>
                                                <td className="text-success fw-bold">{item.mop === "Cash" || item.mop === "Card" ? item.amount : "-"}</td>
                                                <td className="text-danger fw-bold">{item.mop === "Credit" ? item.amount : "-"}</td>
                                            </tr>
                                        ))}
                                        <tr className="table-primary">
                                            <td colSpan={5} className="text-end fw-bold">TOTAL</td>
                                            <td className="text-success fw-bold">{filteredData
                                                .filter((f) => f.mop === "Cash" || f.mop === "Card")
                                                .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)
                                                .toFixed(3)}</td>
                                            <td className="text-danger fw-bold">{filteredData
                                                .filter((f) => f.mop === "Credit")
                                                .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)
                                                .toFixed(3)}</td>
                                        </tr>
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="7">
                                            {searchText ?
                                                `No orders found containing "${searchText}"` :
                                                "No data available"
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </form>

                {/* Printable Report (Hidden from normal view) */}
                <div id="printable-report" style={{ display: 'none' }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2>Customer Transaction Report</h2>
                        </div>

                        <div className="report-info">
                            <p><strong>Report Period:</strong> {fromDate} to {toDate}</p>
                            <p><strong>Generated On:</strong> {new Date().toLocaleDateString()}</p>
                            {selectedCustomer && (
                                <p><strong>Customer:</strong> {data.find(d => d.customer_id === selectedCustomer)?.customer_name}</p>
                            )}
                            {paymentFilter && (
                                <p><strong>Payment Type:</strong> {paymentFilter === "paid" ? "Paid" : "Unpaid"}</p>
                            )}
                            {searchText && (
                                <p><strong>Filtered by Order/Customer:</strong> {searchText}</p>
                            )}
                        </div>

                        <table className="report-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Order No</th>
                                    <th>Customer Name</th>
                                    <th>Payment Method</th>
                                    <th>Paid Amount</th>
                                    <th>Unpaid Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.date}</td>
                                            <td>{item.order_id}</td>
                                            <td>{item.customer_name}</td>
                                            <td>{item.mop}</td>
                                            <td className="text-success">{item.mop === "Cash" || item.mop === "Card" ? parseFloat(item.amount).toFixed(3) : "-"}</td>
                                            <td className="text-danger">{item.mop === "Credit" ? parseFloat(item.amount).toFixed(3) : "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center' }}>
                                            {searchText ?
                                                `No orders found containing "${searchText}"` :
                                                "No data available"
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {filteredData.length > 0 && (
                            <div className="report-totals">
                                <h3>Summary</h3>
                                <div className="total-row">
                                    <span>Total Paid Amount:</span>
                                    <span className="text-success total-amount">{totalPaid.toFixed(3)}</span>
                                </div>
                                <div className="total-row">
                                    <span>Total Unpaid Amount:</span>
                                    <span className="text-danger total-amount">{totalUnpaid.toFixed(3)}</span>
                                </div>
                                <div className="total-row" style={{ borderTop: '1px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>
                                    <span>Grand Total:</span>
                                    <span className="total-amount">{totalAmount.toFixed(3)}</span>
                                </div>
                            </div>
                        )}

                        <div className="footer">
                            <p>Report generated on {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerTransaction;